import { render } from "./VideographersMenuButton.vue?vue&type=template&id=2d54296c&scoped=true&ts=true&lang=pug"
import script from "./VideographersMenuButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideographersMenuButton.vue?vue&type=script&lang=ts&setup=true"

import "./VideographersMenuButton.vue?vue&type=style&index=0&id=2d54296c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d54296c"]])

export default __exports__